import { FormStep } from "../types";

export const handleResetStep = (step: FormStep) => {
  step.value = undefined;
};
